__turbopack_context__.v({
  "active": "Header-module-scss-module__wuH95W__active",
  "backgroundHeader": "Header-module-scss-module__wuH95W__backgroundHeader",
  "blink": "Header-module-scss-module__wuH95W__blink",
  "burguerMenu": "Header-module-scss-module__wuH95W__burguerMenu",
  "copyright": "Header-module-scss-module__wuH95W__copyright",
  "footerElements": "Header-module-scss-module__wuH95W__footerElements",
  "header": "Header-module-scss-module__wuH95W__header",
  "headerMobile": "Header-module-scss-module__wuH95W__headerMobile",
  "logo": "Header-module-scss-module__wuH95W__logo",
  "logoMobile": "Header-module-scss-module__wuH95W__logoMobile",
  "menu": "Header-module-scss-module__wuH95W__menu",
  "menus": "Header-module-scss-module__wuH95W__menus",
  "newsletter": "Header-module-scss-module__wuH95W__newsletter",
  "newsletterText": "Header-module-scss-module__wuH95W__newsletterText",
  "searchForm": "Header-module-scss-module__wuH95W__searchForm",
  "transparent": "Header-module-scss-module__wuH95W__transparent",
  "white": "Header-module-scss-module__wuH95W__white",
});
